import { render, staticRenderFns } from "./sunList.vue?vue&type=template&id=57dd0e12&scoped=true&"
import script from "./sunList.vue?vue&type=script&lang=js&"
export * from "./sunList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dd0e12",
  null
  
)

export default component.exports